import React from 'react';
type KaykoLogoProps = {
  className?: string;
  tone?: 'dark' | 'light';
};
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/sou7esC62jJVBJmDWN72mE/kayko_logo_svg_(1)_(1).svg';
const LOGO_WHITE_URL = 'https://cdn.magicpatterns.com/uploads/dLgBb6hE9kn4VXC9mjGA8y/kayko_logo_white.svg';
export function KaykoLogo({
  className = '',
  tone = 'dark'
}: KaykoLogoProps) {
  return <img src={tone === 'dark' ? LOGO_URL : LOGO_WHITE_URL} alt="Kayko" className={`h-[28px] w-auto ${className}`} data-id="element-654" data-mp="2rab0tw4ks6x2" />;
}